import React from 'react';

const ClubAttendanceTable = ({ attendance }) => {
    return (
        <div className="w-full">
            {/* Desktop Table View */}
            <div className="hidden md:block">
                <table className="w-full">
                    <thead>
                        <tr className="bg-gray-50 border-b border-gray-200">
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Member Name</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Member's Club</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Project Name</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Project's Club</th>
                            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Date</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {attendance.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="px-6 py-8 text-center text-gray-500">
                                    No attendance records found.
                                </td>
                            </tr>
                        ) : (
                            attendance.map((record) => (
                                <tr key={record.id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 text-sm font-medium text-gray-900">{record.member_name}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{record.member_club_name || 'Guest / Unregistered'}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{record.project_name}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{record.host_club_name}</td>
                                    <td className="px-6 py-4 text-sm text-gray-600">{new Date(record.created_at).toLocaleDateString()}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile Grid/Card View */}
            <div className="md:hidden divide-y divide-gray-100">
                {attendance.length === 0 ? (
                    <div className="px-6 py-8 text-center text-gray-500">
                        No attendance records found.
                    </div>
                ) : (
                    attendance.map((record) => (
                        <div key={record.id} className="p-4 space-y-3">
                            <div className="flex justify-between items-start">
                                <div className="font-bold text-gray-900">{record.member_name}</div>
                                <div className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{new Date(record.created_at).toLocaleDateString()}</div>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <div className="text-[10px] font-black text-gray-400 uppercase">Member's Club</div>
                                    <div className="text-xs font-bold text-gray-600">{record.member_club_name || 'Guest'}</div>
                                </div>
                                <div>
                                    <div className="text-[10px] font-black text-gray-400 uppercase">Host Project</div>
                                    <div className="text-xs font-bold text-gray-600">{record.project_name}</div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ClubAttendanceTable;
